<template>
  <ExternalQueryList
      endpoint="/api/v2/payment-conditions"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      @show="paymentCondition => $router.push(getUrl(paymentCondition))"
  >
    <template v-slot:default="{ row: paymentCondition }">
      <td>
        <router-link :to="getUrl(paymentCondition)">
          {{ paymentCondition.attributes.name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  computed: {
    headlines() {
      return [
        {width: 22, text: 'Name'}
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(paymentCondition) {
      return '/payment-conditions/' + paymentCondition.id + '/edit'
    }
  }
}
</script>
